import React from "react";
import TrafficItem from "./TrafficItem";

const TrafficList = ({ data }) => {
  return (
    <div className="trafficList">
      {data.length > 0 ? (
        data.map((item, index) => <TrafficItem key={item.properties.id || `traffic-item-${index}`} item={item} />)
      ) : (
        <p style={{ color: "#003863" }}>Derzeit liegen uns keine Verkehrsmeldungen vor. Borkum Radio wünscht gute Fahrt!</p>
      )}
    </div>
  );
};

export default TrafficList;
